export interface HistoricoIdss {
  cd_registro_ans: number;
  id_precisao: string;
  nr_ano_base: number;
  tp_metodo: string;
  vl_pontuacao: number;
  vl_pontuacao_acreditacao: number;
  vl_pontuacao_bruta: number;
  simulado_badge?: string | null;
  cd_simulado?: number | null;
  tp_simulado?: 'P' | 'C' | 'S' | 'J' | string | null;
}

export interface HistoricoIdssAnosBase {
  nr_ano_base: number; // 2022
}

export type TipoColunaHistoricoIdss = 'OFICIAL' | 'CENARIO' | 'PROJECAO' | 'SIMULADO';

export const TIPO_COLUNA_HISTORICO_IDSS_LABEL: Record<TipoColunaHistoricoIdss, string> = {
  OFICIAL: 'Resultados Oficiais',
  CENARIO: 'Cenário',
  PROJECAO: 'Projeção',
  SIMULADO: 'Simulado',
};

export function classificarColunaHistoricoIdss(
  item: Pick<HistoricoIdss, 'cd_simulado' | 'tp_simulado'>,
): TipoColunaHistoricoIdss {
  if (item?.cd_simulado == null) return 'OFICIAL';
  const tp = String(item.tp_simulado ?? '')
    .toUpperCase()
    .trim();
  if (tp === 'C') return 'CENARIO';
  if (tp === 'P' || tp === 'J') return 'PROJECAO';
  return 'SIMULADO';
}
